import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {IMessage} from '@stomp/stompjs';

import {getMissedCallBellLogsCount, updateMissedCallBellLogsCount} from '@/redux/commonCalls/slice';
import websocketService from '@/services/webSocketService';
import {UnresolvedCallbackCountDTO} from '@/types/gatewayDataModels';

const wsEndpoint = '/topic/callback-request-counter';

export const useMissedCallBellLogsCounter = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMissedCallBellLogsCount());

        websocketService.subscribe(wsEndpoint, (message: IMessage) => {
            const data: UnresolvedCallbackCountDTO = message?.body
                ? (JSON.parse(message?.body) as UnresolvedCallbackCountDTO)
                : null;
            dispatch(updateMissedCallBellLogsCount(data?.unresolvedCallbackCount || 0));
        });
        return () => {
            websocketService.unsubscribe(wsEndpoint);
        };
    }, [dispatch]);
};
